import React from 'react';
import cn from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import { useParticipantNetworkQualityLevel } from 'hooks';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function NetworkStrength() {
  const classes = useStyles();
  const networkQualityLevel = useParticipantNetworkQualityLevel();
  const pids = Array(networkQualityLevel >= 4 ? 3 : networkQualityLevel)
    .fill()
    .map((_, i) => i);

  const stabilityPidStyle = cn(classes.stabilityPid, { [classes.orangeStabilityPid]: pids.length === 2 }, { [classes.redStabilityPid]: pids.length === 1 });

  return (
    <div className={classes.netStability}>
      {pids.map((i) => (
        <div className={stabilityPidStyle} key={i} />
      ))}
    </div>
  );
}

export default NetworkStrength;
